var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',_vm._b({on:{"click":_vm.openModal}},'gl-button',_vm.buttonAttributes,false),[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }